import DialogAlertErrorSimple from "components/DialogAlertErrorSimple/v2";

const DialogErrorForFutureReservationsInDesactivation = ({ dialog }) => {
	return (
		<DialogAlertErrorSimple
			dialog={dialog}
			title="No se puede desactivar el recurso"
			content="Actualmente el recurso cuenta con reservas, para desactivarlo, debes validar que no exista ninguna reserva vigente o futura." />
	);
}

export default DialogErrorForFutureReservationsInDesactivation;